"use strict";

import jQuery from 'jquery';

/**
 * @classdesc
 * Druck-Panel
 *
 * @class
 * @extends gc.gis.widget.GCPanel
 * @memberof gc.gis.module.GCPlot
 * @author Anton Popov <a.popov@brain-scc.de>
 *
 * @param {Object} options Aufrufoptionen
 * @param {gc.gis.module.GCPlot} options.module Modul-Instanz
 */
gc.gis.module.GCPlot.Panel = function( options )
{
	var self = this;

	gc.gis.assert.isSet( options );
	gc.gis.assert.isInstance( options.module, gc.gis.module.GCPlot );

	this.module = options.module;

	this.widget_apply = new gc.gis.widget.GCItem({
		label: 'Anwenden',
		className: 'btn btn-success',
		icon: 'action-apply',
		click: function( evt ) {
			try
			{
				self.form.submit();
			}
			catch( err )
			{
				gc.gis.iface.log.error( self, err );
			}
		}
	});
	this.widget_zoom = new gc.gis.widget.GCItem({
		label: 'Auf Druckbereich zoomen',
		className: 'btn btn-primary',
		icon: 'item-zoom-to',
		click: function( evt ) {
			try
			{
				self.module.zoomToMask();
			}
			catch( err )
			{
				gc.gis.iface.log.error( self, err );
			}
		}
	});

	var options_widget = {
		className: 'gc-plot',
		//target:    '#gc_plot',
		actionbar: new gc.gis.widget.GCMenu({
			containerClassName: 'actionbar',
			items: [
				this.widget_apply,
				this.widget_zoom
			]
		})
	};
	gc.gis.widget.GCPanel.call( this, options_widget );

	this.element = this._render();

    this.module.on(gc.gis.module.GCPlotEvent.SCALE_CHANGED, this, function (evt) {
        self.setScale(evt.scale);
    });

    this._initContent();
};
gc.gis.module.GCPlot.Panel.prototype = Object.create( gc.gis.widget.GCPanel.prototype );

/**
 *
 */
gc.gis.module.GCPlot.Panel.prototype._initContent = function () {
	var self = this;

    // Panel Druckvorlagen
    var panelLayout = {
        label: 'Druckvorlagen',
        type: 'advanced',
        tooltip: 'Druckvorlageneinstellungen ein- oder ausblenden.',
        active: true,
		controls: [
			{
                label: 'Druckvorlage auswählen',
                name: 'plot_layout',
                type: 'select',
                options: this.module.getAvailableLayouts(),
                initFunc: function (control) {
                    self.module.on(gc.gis.module.GCPlotEvent.LAYOUTS_UPDATED, self, function (evt) {
                        control.updateOptions(control.updateFunc.call(this));
                    });
                },
                updateFunc: function () {
                    var layouts = self.module.getAvailableLayouts();
                    var options = [];
                    for (var i = 0; i < layouts.length; i++) {
                        options.push({
                            label: layouts[i].label,
                            data: layouts[i].id
                        });
                    }
                    return options;
                },
                change: function (evt) {
	                var layout_id = undefined;
                	if (evt.target.selectedOptions)
	                {
		                layout_id = jQuery(evt.target.selectedOptions[0]).data('__data');
	                }
	                else
	                {
		                layout_id = jQuery(evt.target.options[evt.target.selectedIndex]).data('__data');
	                }
	                if (layout_id)
	                {
		                self.module.setLayoutByID(layout_id);
	                }
                }
            },
			{
				label: 'Maßstab',
				name: 'plot_scale',
				type: 'scale-selector',
				// scales: this.module.map.getAvailableScales(),
				initFunc: function (control) {
					self.module.on(gc.gis.module.GCPlotEvent.LAYOUT_CHANGED, self, function (evt) {
						// verfügbare Maßstäbe setzen und geeigneten Auswählen
						var current_scale = control.getWidget().getScale();
						var options = self.module.getAvailableScales();

						control.getWidget().setScales(options);

						// ggf. Maßstab-Auswahl setzen
						var scale = options[0].value;
						for (var i = 0; i < options.length; i++) {
							if (options[i].value == current_scale) {
								scale = current_scale;
								break;
							}
						}
						if (scale != current_scale) {
							// value setzen am Modul => Event feuern
							self.module.setScale(scale);
						}
						else {
							// value setzen an Selectbox reicht, da Maßstab nicht geändert wurde
							self.setScale(scale);
						}

						// freie Eingabe zulassen/verbieten
						control.getWidget().enableUserdefinedScale(
							gc.gis.GCUtil.parseBool(evt.layout.enable_userscale, true));

						// Grenzen festlegen
						if (gc.gis.GCUtil.parseBool(evt.layout.enable_scale_bounds, false))
						{
							control.getWidget().setScaleBounds(options[0].value, options[options.length-1].value);
						}
					});
				},
				change: function (scale) {
					self.module.setScale(scale);
				}
			}
            /*,
             {
             label: 'Druckqualität',
             name:  'plot_resolution',
             type: 'select',
             options: this.module.getAvailableResolutions(),
             change: function( evt ) {
             self.module.setResolution( jQuery(this).val() );
             }
             }*/
        ]
    };

    // Panel Inhalt
    var panelContent = {
        label: 'Inhalt',
        type: 'advanced',
        tooltip: 'Erweiterte Druckeinstellungen ein- oder ausblenden.',
        controls: [],
        initFunc: function (control) {
            if (control.controls.length == 0) {
                control.getElement().empty();
                control.getElement().remove();	// FIXME: remove funzt nicht, warum?
            }
        }
    };

    if (this.module.enableEditTitle) {
        panelContent.controls[panelContent.controls.length] = {
            label: 'Titel',
            name: 'plot_title',
            tooltip: 'Der in diesem Feld angegebene Text wird als Titel des Drucks im Druckerzeugnis angezeigt.',
            type: 'text'
        };
    }

    if (this.module.enableEditDescription) {
        panelContent.controls[panelContent.controls.length] = {
            label: 'Beschreibung',
            name: 'plot_description',
            tooltip: 'Der in diesem Feld angegebene Text wird als Beschreibung des Drucks im Druckerzeugnis angezeigt.',
            type: 'textarea'
        };
    }

    if (this.module.enableShowLegend) {
        panelContent.controls[panelContent.controls.length] = {
            label: 'Legende anzeigen',
            name: 'plot_show_legend',
            tooltip: 'Wenn aktiviert, werden die ausgewählten Ebenen in einer Legende im Druckerzeugnis angezeigt. Eine Mehrfachauswahl kann über die Benutzung der STRG- bzw. Umschalttasten erfolgen.',
            type: 'checkbox',
            subForm: {
				controls: [
					{
						// TODO auf Widget LayerSelector umbauen
                        label: 'Legendenebenen',
                        type: 'select',
                        name: 'plot_legend_layers',
                        multiple: true,
                        initFunc: function (control)
                        {
	                        // Wenn das Modul Druck aktibiert wird, müssen die sichtbaren Layer aktiviert werden
	                        // FIXME: bei der Umstellung auf das Widget LayerSelector, werden die Layer-Aktionen überwacht (das ist sauberer)
	                        gc.gis.iface.ui.sidebar.on(gc.gis.ui.GCSidebarEvent.CONTENT_CHANGED, this, function(evt) {
		                        if(evt.newValue && evt.newValue.getElement() === self.module.getElement())
		                        {
			                        control.updateOptions(control.updateFunc.call(this));
		                        }
	                        });
                        },
                        updateFunc: function () {
                            var layers = self.module.map.getReallyVisibleLayers();
                            var options = [];
                            for (var i = layers.length-1; i>=0; i--)
                            {
                            	// FIXME: Legendengrafik auch für externe Layer (WMS/WFS unterstützen)
                                if (layers[i] instanceof gc.gis.layer.GCLayer
	                                && layers[i].isInternal()
	                                && layers[i].getShowLegend())
                                {
                                    options.push({
                                        selected: true,
                                        value: layers[i].getConfig().name,
                                        label: layers[i].getLabel()
                                    });
								}
							}
                            return options;
                        },
                        options: []
					}
				]
			}
        };
    }

    if (this.module.enableShowNorthArrow) {
        panelContent.controls[panelContent.controls.length] = {
            label: 'Nordpfeil anzeigen',
            name: 'plot_show_compass',
            tooltip: 'Wenn aktiviert, wird ein Nordpfeil im Druckerzeugnis angezeigt.',
            type: 'checkbox'
        };
    }

    if (this.module.enableShowAuthor) {
        panelContent.controls[panelContent.controls.length] = {
            label: 'Bearbeiter anzeigen',
            name: 'plot_show_author',
            tooltip: 'Wenn aktiviert, wird der Bearbeiter (Erzeuger) des Drucks im Druckerzeugnis angezeigt.',
            type: 'checkbox'
        };
    }

    if (this.module.enableShowDate) {
        panelContent.controls[panelContent.controls.length] = {
            label: 'Datum anzeigen',
            name: 'plot_show_date',
            tooltip: 'Wenn aktiviert, wird das Erzeugungsdatum des Drucks im Druckerzeugnis angezeigt.',
            type: 'checkbox'
        };
    }

    if (this.module.enableShowScale) {
        panelContent.controls[panelContent.controls.length] = {
            label: 'Maßstab anzeigen',
            name: 'plot_show_scale',
            tooltip: 'Wenn aktiviert, wird der Druckmaßstab im Druckerzeugnis angezeigt.',
            type: 'checkbox'
        };
    }

    if (this.module.enableShowScalebar) {
        panelContent.controls[panelContent.controls.length] = {
            label: 'Maßstabsbalken anzeigen',
            name: 'plot_show_scalebar',
            tooltip: 'Wenn aktiviert, wird im Druckerzeugnis ein Maßstabsbalken angezeigt.',
            type: 'checkbox'
        };
    }

    if (this.module.enableShowCadastral) {
        panelContent.controls[panelContent.controls.length] = {
            label: 'Gemarkung/Flur anzeigen',
            name: 'plot_show_cadastral',
            type: 'checkbox',
            tooltip: 'Wenn aktiviert, werden Gemarkung und Flur auf dem Druckerzeugnis ausgegeben. Aktivierbar bis zu einem Druckmaßstab von 1:10.000.',
            initFunc: function (control)
            {
                self.module.on(gc.gis.module.GCPlotEvent.SCALE_CHANGED, self, function (evt) {
                    var active = (evt.scale <= 10000);
                    control._element.attr('disabled', !active);
                    if (!active) {
                        control._element.attr('checked', false);
                    }
                });
                control._element.attr('disabled', !(self.module.map.getScale() <= 10000));
            }
        };
    }


    var form_config = {
        className: 'form-plot',
        controls: [
            panelLayout,
            panelContent
		],
		validate: function( form, params )
		{
			if(self.module.map.getRotation() % 360 !== 0)
			{
				throw new gc.gis.error.GCError('Drehwinkel werden beim Druck nicht unterstützt. Bitte richten Sie die Karte nach Norden aus.');
			}
		},
		submit: function( form, params )
		{
			var layout = self.module.getLayout();   // ausgewählte Vorlage
			var mmtoinch = 0.0393701;               // 1mm / 25.4mm/inch
			var dpi = 96;

			//form.setLoading(true, 'Erstelle Druck ... ');
			params.plot_center = self.module.map.getCenter();
			params.plot_projection = self.module.map.getProjection();
			params.plot_rotation = self.module.map.getRotation();
			params.plot_scale = params.plot_scale;
			params.plot_layout = layout.id;
			params.plot_layers = [];
			params.plot_bbox = self.module.getMaskExtent();

			if (self.module.map.getVisibleBackgroundLayer())
			{
				//	WMTS-Aufruf wird nicht unterstützt
				var backgroundLayerData = self.module.map.getVisibleBackgroundLayer().toObject();
				if (backgroundLayerData.type === 'wms'
					&& backgroundLayerData.originalType === 'external_wms'
					&& typeof backgroundLayerData.externalConnection !== 'undefined'
					&& backgroundLayerData.externalConnection.source === 'wmts'
				)
				{
					throw new gc.gis.error.GCError('WMTS-Dienste werden für Hintergrundkarten im Druckmodus nicht unterstützt. Bitte wählen Sie eine andere Hintergrundkarte.');
				}
				params.plot_layers.push(backgroundLayerData);
			}

			// Layer in Parameter aufnehmen
			var layers = self.module.map.getReallyVisibleLayers();
			for(var i=0; i<layers.length; i++)
			{
				if( !(layers[i] instanceof gc.gis.layer.GCGroupLayer) )
				{
					params.plot_layers.push(layers[i].toObject());
				}
			}

			// Größe des Druckbereichs in Pixeln ermitteln
			var size = [
				Math.ceil(layout.width * mmtoinch * dpi),
				Math.ceil(layout.height * mmtoinch * dpi)
			];

			// wenn Tracking-Layer-Objekte vorhanden sind (abzüglich Papiermaske) => mit Screenshot
			if (self.module.map.getMap().numTrackingLayersFeatures()
				- self.module.getMaskTrackingLayer().numFeatures() > 0)
			{
				jQuery.when(self.module.map.dumpCanvasTrackingLayerByBox(params.plot_bbox, size))
					.done(function (dump) {
						params.trackinglayers = dump;
						self.module.executePlotRequest(params);
					});
			}
			else
			{
				self.module.executePlotRequest(params);
			}

			//form.setLoading(false);
		},
		error: function( form, err )
		{
			form.setLoading( false );
		}
	};
	this.form = gc.gis.util.GCFormRenderer.renderForm( form_config );

	this.element_content.append( this.form.getElement() );

	// this.element_loading = jQuery('<div>', {
	// 	'class': 'gc-views-loading'
	// });
	// this.element_content.append( this.element_loading );
};

/**
 *
 */
gc.gis.module.GCPlot.Panel.prototype.setScale = function(scale)
{
	this.form.get('plot_scale').getWidget().setScale(scale);
};
